import { sync } from 'vuex-router-sync'

const useVuexRouterSyncPlugin = function (container) {
  sync(container.store, container.router)
}

export default useVuexRouterSyncPlugin



// WEBPACK FOOTER //
// ./src/plugins/vuex-router-sync.js